import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { api } from 'lib/axios';
import { SignInError, SignInRequest, SignInResponse } from './types';

export const useSignIn = () => {
  const { isError, isLoading, data, mutateAsync, error } = useMutation<
    SignInResponse,
    AxiosError<SignInError>,
    SignInRequest,
    SignInResponse
  >((args) => api.post('/auth/login', args).then((res) => res.data));

  return {
    signIn: mutateAsync,
    isError,
    isLoading,
    data,
    error,
  };
};
